export class Menu {
    constructor() {
        this.menuFlag = false;
        this.$menuWrap = $('.js-menu-wrap');
        this.$content = $('.js-transform-wrap');
        this.$header = $('.js-header-wrap');
        this.DURATION = 500;

        this.bindEvents();
    }



    /**
     * Открываем
     */
    open() {
        if (this.menuFlag) { return; }
        this.menuFlag = true;
        App.menuIsOpen = true;

        App.H.addClass('_menu-open');

        this.resizeContent();

        App.lockScroll.lock();


        setTimeout(() => {
            this.menuFlag = false;
        }, this.DURATION);


        // Ставим фокус на первую ссылку (для Tab-навигации)
        if (!App.mobile) {
            setTimeout(() => {
                this.$menuWrap.find('.js-menu .js-close-menu').focus();
            }, this.DURATION);
        }
    }



    /**
     * Закрываем
     */
    close() {
        if (this.menuFlag) return;
        this.menuFlag = true;
        App.menuIsOpen = false;

        App.H.removeClass('_menu-open');
        this.returnContent();


        setTimeout(() => {
            App.lockScroll.unlock();
        }, this.DURATION);

        setTimeout(() => {
            this.menuFlag = false;
        }, this.DURATION);


        // Возвращаем фокус на бургер (для Tab-навигации)
        if (!App.mobile) {
            setTimeout(() => {
                $('.js-burger').focus();
            }, this.DURATION);
        }
    }


    /**
     * Биндим открытие и закрытие
     */
    bindEvents() {

        // Открыть кнопкой
        $('.js-burger').on('click', () => {
            if (this.menuFlag) { return; }

            if (App.menuIsOpen) {
                this.close();
            } else {
                this.open();
            }
        });


        // Закрыть кнопкой
        $('.js-close-menu').on('click', () => {
            this.close();
        });


        // Закрыть меню клавишей Escape
        App.W.on('keydown', (e) => {
            if (App.menuIsOpen && e.keyCode == 27) {
                this.close();
            }
        });
    }



    /**
     * Делаем «зум» контентной области
     */
    resizeContent() {

        // Находим коэффициент для transform (исходя из ширины меню)
        const t = (1 - (this.$menuWrap.width() / App.H.width())).toFixed(3);


        // Находим точку для transform-origin (чтобы было относительно центра экрана)
        let origin = 'right top';

        /**
         * Когда находимся в самом верху страницы,
         * лучше выглядит, когда зумим относительно верхнего угла,
         * в остальных случаях — относительно центра экрана
         */

        if (App.W.scrollTop() > App.H.height() / 2) {
            console.log(this.$content.height());
            const percent = (App.H.height() / 2 + App.W.scrollTop()) / this.$content.height() * 100;
            origin = `right ${percent}%`;
        }

        this.$content.css({
            'transform-origin': origin,
            'transform': `scale(${t})`
        });


        /**
         * Хедер находится вне контентной области
         * (fixed не работает внутри transform),
         * поэтому к нему применяем трансформ отдельно
         */
        this.$header.css({
            'transform': `scale(${t})`
        });
    }



    /**
     * Возвращаем контентрую область к нормальному виду
     */
    returnContent() {
        this.$content
            .add(this.$header)
            .css({
                transform: 'scale(1)'
            });
    }
}

new Menu();



// WEBPACK FOOTER //
// ./_src/js/modules/Menu.js